import React, { FC } from 'react';
import _ from 'lodash';
import { Heading } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { SEO_EXPLORE_PAGE_MAP } from '../../../utils/constants';
import { useExploreContext } from '../../Contexts/ExploreContext';

type Props = {
  dataHook: string;
  isMobileView: boolean;
};

const PageTitle: FC<Props> = ({ dataHook, isMobileView }) => {
  const { t } = useTranslation();
  const {
    state: { category, service },
  } = useExploreContext();

  function renderPageTitle() {
    if (SEO_EXPLORE_PAGE_MAP[_.get(service, 'pathName')]) {
      return t(SEO_EXPLORE_PAGE_MAP[service.pathName].h1);
    }
    if (
      service &&
      !_.startsWith(
        t(`explore.services.${service.displayKey}`),
        'explore.services',
      )
    ) {
      return t(SEO_EXPLORE_PAGE_MAP.default.h1, {
        serviceName: t(`explore.services.${service.displayKey}`),
      });
    }
    if (!service && category && SEO_EXPLORE_PAGE_MAP[category.pathName]) {
      return t(SEO_EXPLORE_PAGE_MAP[category.pathName].h1);
    }
    return t('explore-page-heading-multiple-services');
  }

  return (
    <Heading
      as="h1"
      size={isMobileView ? 'large' : 'extraLarge'}
      dataHook={dataHook}
    >
      {renderPageTitle()}
    </Heading>
  );
};

export default PageTitle;
